"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fmdConfigTypes = exports.fmdConfigMap = exports.daysMap = exports.days = exports.FMDConfig = void 0;
var _icons = require("../components/icons");
const fmdConfigTypes = exports.fmdConfigTypes = ['distance', 'daily', 'dailyAndDistance', 'fixed'];
const days = exports.days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const daysMap = exports.daysMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const fmdConfigMap = exports.fmdConfigMap = {
  distance: {
    key: 'distance',
    Icon: _icons.DistanceIcon,
    labelKey: 'commons.fmd.types.distance',
    explanationsLabelKey: 'commons.fmd.explanations.distance',
    rateLabelKey: 'commons.fmd.rate_label.distance',
    rateUnitKey: 'commons.fmd.rate_unit.distance',
    valueLabelKey: 'companies.pages.bicycle_compensation.certificates_table.value_label_distance'
  },
  daily: {
    key: 'daily',
    Icon: _icons.CalendarIcon,
    labelKey: 'commons.fmd.types.daily',
    explanationsLabelKey: 'commons.fmd.explanations.daily',
    rateLabelKey: 'commons.fmd.rate_label.daily',
    rateUnitKey: 'commons.fmd.rate_unit.daily',
    valueLabelKey: 'companies.pages.bicycle_compensation.certificates_table.value_label_daily'
  },
  fixed: {
    key: 'fixed',
    Icon: _icons.LockOutlinedIcon,
    labelKey: 'commons.fmd.types.fixed',
    explanationsLabelKey: 'commons.fmd.explanations.fixed',
    rateLabelKey: 'commons.fmd.rate_label.fixed',
    valueLabelKey: 'companies.pages.bicycle_compensation.certificates_table.value_label_fixed'
  },
  dailyAndDistance: {
    key: 'dailyAndDistance',
    Icon: _icons.DailyAndDistanceIcon,
    labelKey: 'commons.fmd.types.daily_and_distance',
    explanationsLabelKey: 'commons.fmd.explanations.daily_and_distance',
    rateLabelKey: 'commons.fmd.rate_label.daily',
    rateUnitKey: 'commons.fmd.rate_unit.daily',
    valueLabelKey: 'companies.pages.bicycle_compensation.certificates_table.value_label_daily'
  }
};
class FMDConfig {
  constructor(id, partner, code, type, compensationRate, distanceCompensationRate, maxCompensationPerYear, fixedFMDLevels, minDaysCountPerMonth, certificateValidationLimitDay, compensableDays, enableReceiptionOfCertificates, maxManuallyDeclaredJourneysRatio, annualPeriodStartDay, annualPeriodStartMonth, annualPeriodEndDay, annualPeriodEndMonth) {
    this.id = id;
    this.partner = partner;
    this.code = code;
    this.type = type;
    this.compensationRate = compensationRate;
    this.distanceCompensationRate = distanceCompensationRate;
    this.maxCompensationPerYear = maxCompensationPerYear;
    this.fixedFMDLevels = fixedFMDLevels;
    this.minDaysCountPerMonth = minDaysCountPerMonth;
    this.certificateValidationLimitDay = certificateValidationLimitDay;
    this.compensableDays = compensableDays;
    this.enableReceiptionOfCertificates = enableReceiptionOfCertificates;
    this.maxManuallyDeclaredJourneysRatio = maxManuallyDeclaredJourneysRatio;
    this.annualPeriodStartDay = annualPeriodStartDay;
    this.annualPeriodStartMonth = annualPeriodStartMonth;
    this.annualPeriodEndDay = annualPeriodEndDay;
    this.annualPeriodEndMonth = annualPeriodEndMonth;
  }
}
exports.FMDConfig = FMDConfig;